module.exports = __webpack_public_path__ + "static/img/oseas.26ed6d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/oseas.jpg
// module id = UwJ8
// module chunks = 0